<template>
  <Modal>
    <Modal.Title>Add copyright owner</Modal.Title>
    <Modal.Body>
      <CopyrightOwnerTypeSelection v-model="type" class="mb-[14px]" />

      <Input
        v-if="isPersonal"
        v-model="name"
        size="xl"
        :label="label"
        :disabled="loading"
      />

      <OrganizationSearch
        v-else
        v-model="selectedOrg"
        :label="label"
        :disabled="loading"
        @update:query="handleNameUpdate"
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button variant="primary" :loading="loading" @click="handleSave">
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, useModal } from '@dacr/library'
import CopyrightOwnerTypeSelection from '@/features/copyright/components/CopyrightOwnerTypeSelection.vue'
import OrganizationSearch from '@/features/search/components/OrganizationSearch.vue'
import { useNewCopyrightOwner } from './useNewCopyrightOwner'

const { close } = useModal()
const {
  name,
  selectedOrg,
  type,
  isPersonal,
  label,
  loading,
  handleNameUpdate,
  save,
} = useNewCopyrightOwner()

const handleSave = async () => {
  await save()
  close()
}
</script>
